import { Result } from 'antd';
import { AppstoreOutlined } from '@ant-design/icons';

export default function OtherReport() {
  return (
    <Result
      icon={<AppstoreOutlined />}
      title="其他报表"
      subTitle="此功能正在开发中，敬请期待"
    />
  );
}
